import { FC, useMemo } from 'react';
import DistributionBars from '../../../shared/charts/DistributionBars';
import { DistributionSlice } from '../../../shared/charts/chart.types';
import { ITrainingMixSubcategorySlice } from '../../../models/allenamenti';
import { FALLBACK_CATEGORY_COLOR } from '../allenamenti.constants';
import { formatMinutes } from './analysis.constants';
import Typhography from '../../../shared/Typhography/Typhography';
import styles from './PhysicalSubcategoryBars.module.scss';

interface IPhysicalSubcategoryBarsProps {
  slices: ITrainingMixSubcategorySlice[];
  bySlug: Map<string, { labelIt: string; color: string }>;
}

/**
 * Adapter sottile su shared/charts/DistributionBars per le sottocategorie
 * fisiche (le 6 macro `isPhysical`, già filtrate lato server). La
 * percentuale di ogni barra è sul totale dell'INTERO periodo (tutte le
 * categorie, non solo quelle fisiche): coerente col donut per categoria
 * sullo stesso 100% — l'endpoint la calcola già così, qui non si ritocca.
 */
const PhysicalSubcategoryBars: FC<IPhysicalSubcategoryBarsProps> = ({ slices, bySlug }) => {
  const data: DistributionSlice[] = useMemo(
    () =>
      slices.map((s) => ({
        id: s.key,
        label: bySlug.get(s.key)?.labelIt ?? s.key,
        value: s.minutes,
        percent: s.percentage,
        color: bySlug.get(s.key)?.color ?? FALLBACK_CATEGORY_COLOR,
      })),
    [slices, bySlug],
  );

  return (
    <div className={styles.card}>
      <Typhography type="h3" size="bold-14" className={styles.title}>Sottocategorie fisiche</Typhography>
      <DistributionBars data={data} valueFormatter={formatMinutes} labelMode="value-percent" />
    </div>
  );
};

export default PhysicalSubcategoryBars;
